import { createBigDecimal } from '@0xtorch/big-decimal'
import type { Action } from '@0xtorch/core'
import type { Chain } from '../../../chain'
import type { LowerHex } from '../../../types'
import type { TransactionDecoded } from '../../../types/transactionDecoded'
import { createEvmAddressId } from '../../../utils'

type CreateActionsByGasAnalyzerParameters = {
  chain: Chain
  transaction: TransactionDecoded
  relatedAddresses: Set<LowerHex>
  source: string
}

export const createActionsByGasAnalyzer = ({
  chain,
  transaction,
  relatedAddresses,
  source,
}: CreateActionsByGasAnalyzerParameters): readonly Action[] | undefined => {
  // gas fee が 0 の場合は、 undefined を返す
  if (
    transaction.gasUsed === 0n ||
    transaction.gasUsed === null ||
    transaction.effectiveGasPrice === 0n ||
    transaction.effectiveGasPrice === null
  ) {
    return undefined
  }

  // from address が related addresses に含まれていない場合は、 undefined を返す
  if (!relatedAddresses.has(transaction.from.address)) {
    return undefined
  }
  const fromId = createEvmAddressId({
    chainId: transaction.chainId,
    address: transaction.from.address,
  })

  // transaction gas fee から action 作成
  return [
    {
      type: 'transaction-fee',
      timestamp: transaction.timestamp,
      source,
      order: 0,
      evidence: 'system-rule',
      transfers: [
        {
          from: fromId,
          asset: chain.nativeToken.currency,
          amount: createBigDecimal(
            transaction.gasUsed * transaction.effectiveGasPrice,
            chain.nativeToken.decimals,
          ),
          direction: 'out',
        },
      ],
    },
  ]
}
